import { useSelector } from 'react-redux';
import { Intent } from 'signup-constants/Intent';
import { getIsQa } from '../constants/apiEnvironments';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { getQueryParam } from '../routing/getQueryParam';
import { getActiveError } from '../store/error/selectors';
import { getPostVerificationSteps, getPreVerificationSteps } from '../store/flow/selectors';
import { getActiveLoading } from '../store/loading-status/selectors';
import { isIntent } from '../utils/isIntent';
import { getStepConfig } from '../views/getStepConfig';
import { useCurrentStep } from './useCurrentStep';
export const useLayoutTemplate = () => {
  const postVerificationSteps = useSelector(getPostVerificationSteps);
  const preVerificationSteps = useSelector(getPreVerificationSteps);
  const {
    currentStep
  } = useCurrentStep();
  const activeError = useSelector(getActiveError);
  const step = activeError || currentStep;
  const stepConfig = getStepConfig(step);
  const shouldFlowUseLayoutTemplate = getFlowConfig().shouldFlowUseLayoutTemplate;
  const isQa = getIsQa();
  const enabledByQueryParam = getQueryParam('use_layout');
  const isCampaignAssistant = isIntent(Intent.campaignAssistant);
  const activeLoading = useSelector(getActiveLoading);
  const shouldStepUseLayoutTemplate = stepConfig ? stepConfig.shouldStepUseLayoutTemplate : false;
  const isPreAccountCreationStep = [...postVerificationSteps, ...preVerificationSteps].includes(currentStep);
  const isLayoutTemplateUngated = isQa && enabledByQueryParam || shouldFlowUseLayoutTemplate;

  if (activeLoading || activeError || !isPreAccountCreationStep || isCampaignAssistant) {
    return {
      shouldUseLayoutTemplate: false
    };
  }

  if (isLayoutTemplateUngated && shouldStepUseLayoutTemplate) {
    return {
      shouldUseLayoutTemplate: true
    };
  }

  return {
    shouldUseLayoutTemplate: false
  };
};